import { PackingTypeSale } from 'enums/packingTypeSale';

type ValidMultipleParams = {
  value: number;
  multiple: number;
  packingType: PackingTypeSale;
  maxAvailable: string;
  valueTypeSale?: number;
  label?: string;
};

const parseMaxAvailable = (maxAvailable: string): number[] =>
  maxAvailable.split('x').map(x => parseInt(x, 10));

const multiplyArray = (numbers: number[]): number =>
  numbers.reduce((acc, num) => acc * num, 1);

const calculateTotalUnits = (
  value: number,
  maxAvailable: string,
  packingType: PackingTypeSale,
): number => {
  const calculations = {
    [PackingTypeSale.Packing]: () => value * parseInt(maxAvailable, 10),
    [PackingTypeSale.Layer]: () => value * multiplyArray(parseMaxAvailable(maxAvailable)),
    [PackingTypeSale.Trolley]: () => value * multiplyArray(parseMaxAvailable(maxAvailable)),
  } as const;

  return calculations[packingType]?.() ?? value;
};

const createValidationError = (
  multiple: number,
  valueTypeSale: number,
  label: string,
): Error =>
  new Error(
    `A quantidade não é múltipla de ${valueTypeSale ?? multiple} ${
      label ?? 'unidades'
    }`,
  );

const isValidMultiple = (totalUnits: number, multiple: number): boolean =>
  totalUnits % multiple === 0;

export const validatorUtils = {
  validMultipleWithNamedParams(params: ValidMultipleParams): Promise<void> {
    const {
      value,
      multiple,
      packingType,
      maxAvailable,
      valueTypeSale,
      label = 'unidades',
    } = params;

    if (!value || !multiple) return Promise.resolve();

    const totalUnits = calculateTotalUnits(value, maxAvailable, packingType);

    return isValidMultiple(totalUnits, multiple)
      ? Promise.resolve()
      : Promise.reject(
          createValidationError(multiple, valueTypeSale || multiple, label),
        );
  },
    validMultiple(
    value: number,
    multiple: number,
    selectedTypeSale: string,
    maxAvailable: string,
    valueTypeSale: number,
    label?: string,
  ) {
    if (
      (value * parseInt(maxAvailable, 10)) % multiple > 0 &&
      selectedTypeSale === PackingTypeSale.Packing
    ) {
      return Promise.reject(
        new Error(
          `A quantidade não é múltipla de ${valueTypeSale ?? multiple} ${
            label ?? 'unidades'
          }`,
        ),
      );
    }

    const values = maxAvailable.split('x');
    const totalUnits =
      parseInt(values[0], 10) * parseInt(values[1], 10) * value;
    if (totalUnits % multiple > 0) {
      return Promise.reject(
        new Error(
          `Quantidade não e múltipla de ${valueTypeSale ?? multiple} ${
            label ?? 'unidades'
          }`,
        ),
      );
    }
    return Promise.resolve();
  },
};